/**
 * PinnedDisplayItem object.
 *
 * @typedef {Object} PinnedDisplayItem
 * @namespace
 *
 * @memberof Common.Model.Entity
 *
 * @property {Integer} id The item id.
 * @property {Object} meta Object storing the associated meta information. (contentType, network)
 * @property {Assets} assets Object storing the associated image assets for the item (main/thumbnail)
 */

class PinnedDisplayItem {
  constructor(id, meta, assets) {
    this.id = id;
    this.meta = meta;
    this.assets = assets;
    this.content = {};
    this.profile = {};
    this.review = {};
    this.actions = {};
    this.embed = {};
    this.originalContent = {};
  }
}

export default PinnedDisplayItem;
